import * as yup from 'yup';
import { ParticipantPermission } from 'livekit-server-sdk';

import { endpoint, EndpointError } from 'endpoints/endpoint';

import { ERROR as VALIDATION_ERROR } from '../validation';

export type UpdatePermissionsParams = {
  permissions: Partial<ParticipantPermission>;
  userId: string;
  roomId: string;
};
export type UpdatePermissionsResult = { data: 'OK' };
export type UpdatePermissionsError = EndpointError;

export const updatePermissionsParamsSchema: yup.SchemaOf<UpdatePermissionsParams> = yup.object().shape({
  permissions: yup
    .object()
    .shape({
      canSubscribe: yup.boolean(),
      canPublish: yup.boolean(),
      canPublishData: yup.boolean(),
    })
    .required(VALIDATION_ERROR.REQUIRED),
  userId: yup.string().required(VALIDATION_ERROR.REQUIRED),
  roomId: yup.string().required(VALIDATION_ERROR.REQUIRED),
});

export const updatePermissions = endpoint<UpdatePermissionsParams, UpdatePermissionsResult, UpdatePermissionsError>({
  method: 'POST',
  url: () => '/live-kit/update-permissions',
});
